module.exports = __webpack_public_path__ + "img/expert-7.2ccc6469.png";